"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BuildFill = {
    name: 'build',
    theme: 'fill',
    nameWithTheme: 'build-fill',
    tag: 'svg',
    attrs: {
        xmlns: 'http://www.w3.org/2000/svg',
        class: 'icon',
        viewBox: '0 0 1024 1024'
    },
    children: [
        {
            tag: 'path',
            attrs: {
                d: 'M916 210H376c-17.7 0-32 14.3-32 32v236H108c-17.7 0-32 14.3-32 32v272c0 17.7 14.3 32 32 32h540c17.7 0 32-14.3 32-32V546h236c17.7 0 32-14.3 32-32V242c0-17.7-14.3-32-32-32zM612 746H412V546h200v200zm268-268H680V278h200v200z'
            },
            children: []
        }
    ]
};
exports.default = BuildFill;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@ant-design/icons/lib/fill/BuildFill.js
// module id = 363
// module chunks = 0